<template>
  <admin-only redirectOnNotAuthorized>
    <v-container fluid>
      <v-toolbar color="white">
        <h2 class="headline ml-5"> <v-icon>mdi-arrow-left-right</v-icon> Export Settings</h2>
      </v-toolbar>
      <v-row class="mt-1">
        <v-col class="pr-1" :cols="4">
          <v-card>
            <v-card-title>
              <h2 class="headline ml-5"> <v-icon>mdi-arrow-left-right</v-icon> Export Options</h2>
            </v-card-title>
            <v-card-text>
              <v-text-field
                  v-model="exporterSettings.firmenkennzeichen"
                  @input="onSettingsChanged"
                  label="Firmenkennzeichen"
              />
              <v-text-field
                  type="number"
                  v-model="exporterSettings.firmennummer"
                  @input="onSettingsChanged"
                  label="Firmennummer"
              />
              <v-text-field
                  type="number"
                  v-model="exporterSettings.satzart"
                  @input="onSettingsChanged"
                  label="Satzart"
              />
              <v-checkbox
                v-model="exporterSettings.removeHaushaltsstelle"
                @change="onSettingsChanged"
                label="Haushaltsstelle entfernen"
                />
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" :disabled="!exporterSettingsChanged" @click="saveExporterSettings">Speichern</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col class="pl-1">
            <v-card>
              <v-card-title>
                <h2 class="headline ml-5"> <v-icon>mdi-alarm</v-icon> Zeitmodell</h2>
                <v-btn
                    @click="showTimeModelDialog = true"
                    color="blue darken-4"
                    dark
                    small
                    absolute
                    right
                    fab
                >
                  <v-icon>mdi-plus-circle-outline</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-simple-table>
                  <thead>
                    <tr>
                      <th class="text-left">Name</th>
                      <th class="text-left">Montag</th>
                      <th class="text-left">Dienstag</th>
                      <th class="text-left">Mittwoch</th>
                      <th class="text-left">Donnerstag</th>
                      <th class="text-left">Freitag</th>
                      <th class="text-left">Samstag</th>
                      <th class="text-left">Sonntag</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="timeModel in timeModels" :key="timeModel.id" @click="selectedTimeModel = timeModel; showTimeModelDialog= true">
                      <td valign="top">{{timeModel.name}}</td>
                      <td valign="top"><day-hours v-model="timeModel.monday" readonly /></td>
                      <td valign="top"><day-hours v-model="timeModel.tuesday" readonly /></td>
                      <td valign="top"><day-hours v-model="timeModel.wednesday" readonly /></td>
                      <td valign="top"><day-hours v-model="timeModel.thursday" readonly /></td>
                      <td valign="top"><day-hours v-model="timeModel.friday" readonly /></td>
                      <td valign="top"><day-hours v-model="timeModel.saturday" readonly /></td>
                      <td valign="top"><day-hours v-model="timeModel.sunday" readonly /></td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card-text>
            </v-card>
        </v-col>
      </v-row>
      <v-dialog v-model="showTimeModelDialog" :persistent="true" max-width="90%">
        <time-model
          v-if="showTimeModelDialog"
          :initialTimeModel="selectedTimeModel"
          @cancel="cancelTimeModelOperation"
          @save="confirmTimeModelOperation"
        />
      </v-dialog>
    </v-container>
  </admin-only>
</template>

<script>
import { mapState } from 'vuex';
import timeparkApi from '../timeparkApi';
import TimeModel from './timeModels/TimeModel';
import DayHours from './timeModels/DayHours';

export default {
  name: 'ExporterSettings',
  components: {
    TimeModel,
    DayHours,
  },
  mounted() {
    this.reloadData();
  },
  computed: {
    ...mapState(['timeModels']),
  },
  methods: {
    async reloadData() {
      const apiResult = await timeparkApi.getExporterSettings();
      this.exporterSettings = apiResult.data;
    },
    async saveExporterSettings() {
      const apiResult = await timeparkApi.saveOrUpdateExporterSettings(this.exporterSettings);

      this.exporterSettings = apiResult.data;
      this.exporterSettingsChanged = false;
    },
    onSettingsChanged() {
      this.exporterSettingsChanged = true;
    },
    cancelTimeModelOperation() {
      this.showTimeModelDialog = false;
      this.selectedTimeModel = null;
    },
    async confirmTimeModelOperation(timeModel) {
      let apiResult = null;

      if (this.selectedTimeModel) {
        const data = {
          id: this.selectedTimeModel.id,
          ...timeModel
        };

        apiResult =  await timeparkApi.editTimeModel(data);
      } else {
        apiResult =  await timeparkApi.createTimeModel(timeModel);
      }

      this.$store.commit('setTimeModels', apiResult.data);

      this.showTimeModelDialog = false;
      this.selectedTimeModel = null;
    },
  },
  data: () => ({
    exporterSettings: {},
    exporterSettingsChanged: false,
    showTimeModelDialog: false,
    selectedTimeModel: null,
    items: [
      { icon: 'folder', iconClass: 'grey lighten-1 white--text', title: 'Photos', subtitle: 'Jan 9, 2014' },
      { icon: 'folder', iconClass: 'grey lighten-1 white--text', title: 'Recipes', subtitle: 'Jan 17, 2014' },
      { icon: 'folder', iconClass: 'grey lighten-1 white--text', title: 'Work', subtitle: 'Jan 28, 2014' },
    ],
    items2: [
      { icon: 'assignment', iconClass: 'blue white--text', title: 'Vacation itinerary', subtitle: 'Jan 20, 2014' },
      { icon: 'call_to_action', iconClass: 'amber white--text', title: 'Kitchen remodel', subtitle: 'Jan 10, 2014' },
    ],
  }),
};
</script>
